import Vue from 'vue';
import Quasar from 'quasar';
import frag from 'vue-frag';

import '../src/i18n/i18n';
import '../src/styles/quasar.scss';
import 'quasar/src/css/index.styl';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css';

Vue.use(Quasar, {
  config: {},
  plugins: {},
});

Vue.directive('frag', frag);
